<template>
  <div
    class="container"
    @click="$emit('focus', presed)"
  >
    <input
      type="text"
      :placeholder="defaultPlaceholder"
      :value="searchFieldValue"
    >
    <div class="container__img">
      <img
        src="@/static/icons/ic_search.svg"
      >
    </div>
  </div>
</template>

<script>
export default {

  props: {
    placeholder: { type: String, default: null },
  },

  emits: ['focus'],

  data() {
    return {
      presed: true,
      searchFieldValue: '',
    };
  },
  computed: {
    defaultPlaceholder() {
      if (!this.placeholder) {
        return this.$t('searchEmpty.placeholder');
      }
      return this.placeholder;
    },
  },
  methods: {
    /**
     * Sets the value of the input.
     * @public
     * @param {string} val - The value to set.
     * @returns {void}
     */
    SetValueInput(val) {
      this.searchFieldValue = val;
    },
  },
};
</script>

<style scoped lang="scss">
.container {
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-wrap: nowrap;
  height: 55px;
}

.container__img {
  height: 47px;
  width: 47px;
  background: #fff;
  display: flex;
  flex-direction: column;
  align-content: center;
  justify-content: center;
  border-bottom-right-radius: 5px;
  border-top-right-radius: 5px;
}

.container img {
  width: 24px;
  height: 24px;
  background: #fff;
  margin-left: 25%;
}

.container input {
  height: 47px;
  width: 100%;
  background: #fff;
  margin-right: 0;
  border-bottom-left-radius: 5px;
  border-top-left-radius: 5px;
  padding-left: 8px;
}
</style>
